import { STATUS_COLORS } from "../lib/api";

export function StatusBadge({ status }) {
  const cls = STATUS_COLORS[status] || "bg-zinc-700/40 text-zinc-300 border-zinc-600";
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${cls}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}
